import { Inject, Injectable } from '@angular/core';
import { ConstantMan } from '../constantMan';
import { first } from 'rxjs/operators';
import { ApiHelper } from '../apiHelper';
import { BaseDAO } from './baseDAO';
import { DeviceInfoService } from '../device-info/device-info.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class LoggingDAO extends BaseDAO<ILoggingModel> {
  constructor(
    apiHelper: ApiHelper,
    private readonly deviceInfoService: DeviceInfoService,
  ) {
    super(apiHelper, ConstantMan.API.RESOURCE.LOGGING);
  }

  serverTag(loggingModel: Partial<ILoggingModel>): void {
    const url = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers = this.apiHelper.getDefaultHeader();
    const data = loggingModel;
    const metadata = this.deviceInfoService.getLoggingInfo();
    if (data && data.ancillary) {
      data.ancillary.metadata = metadata;
    } else {
      data.ancillary = {
        metadata: metadata,
      };
    }

    this.apiHelper
      .apiCall<any>(url, method, null, data, headers)
      .pipe(first())
      .subscribe();
  }

  getByIdAndTypes(vesselId: number, types: string[]) {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      vesselId +
      '?types=' +
      types.join(',');
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }
}

// should mirror log lib from api
export interface ILoggingModel {
  name: string;
  description: string;
  className: string;
  ancillary: any;
  createdAt: Date;
  updatedAt: Date;
}
